import objectize from './objectize';

const normalize = (data, key = 'id') => {
  return objectize(data, key);
};

export default normalize;
